// extracted by css-extract-rspack-plugin
export default {"wrapper":"u_516","icon":"ABelU","input":"jfHgZ"};